import { useCallback, useMemo } from "react";

export function useValue({ valueField, staticOptions, isMulti, controllerField, selectedOptions, onChange, valueGetter, endPoint, setSelectedOptions }) {

  const value = useMemo(() => {
    const value = controllerField ? controllerField.value : selectedOptions;

    if (valueField && staticOptions) {
      if (isMulti) {
        return staticOptions.filter(option => value?.includes(valueGetter(option)));
      }
      return staticOptions.find(option => valueGetter(option) === value);
    }
    return value;
  }, [valueField, staticOptions, controllerField, selectedOptions, isMulti, valueGetter]);

  const handleOnChange = useCallback((data) => {
    let value = data;
    if (valueField && !endPoint) {
      value = isMulti ? data.map(valueGetter) : valueGetter(data);
    }

    if (controllerField) {
      controllerField.onChange(value);
    } else {
      setSelectedOptions(value);
    }

    onChange?.(value);
  }, [valueField, isMulti, valueGetter, controllerField, setSelectedOptions, endPoint, onChange]);

  return { value, handleOnChange };
};
